import { useScrollStore } from "@faire/web/common/ScrollStore";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React, { useEffect } from "react";

import { usePromoBannerStore } from "@faire/retailer/stores/ui/PromoBannerStore";

import HeaderSearch from "../HeaderSearch";

import { MenuContainer } from "./styled";

interface IProps {
  inputId: string;
  inputDataTestId: string;
}

export const HeaderMobileSearch: React.FC<IProps> = (props) => {
  const viewport = useViewport();
  const { visibleHeight } = usePromoBannerStore(["visibleHeight"]);
  const { pushNoScroll, popNoScroll } = useScrollStore([
    "pushNoScroll",
    "popNoScroll",
  ]);
  useEffect(() => {
    pushNoScroll();
    return () => {
      popNoScroll();
    };
  }, [popNoScroll, pushNoScroll]);

  return (
    <MenuContainer style={{ top: 0, height: "100%" }} $height={visibleHeight}>
      {viewport.isMobile ? (
        <HeaderSearch
          inputId={props.inputId}
          inputDataTestId={props.inputDataTestId}
        />
      ) : null}
    </MenuContainer>
  );
};
